"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.q = q;
exports.tagQClause = tagQClause;
exports.jobAccessUrl = jobAccessUrl;
function q(...spec) {
    return spec
        .map((qPart) => {
        let qValue;
        switch (qPart.operator) {
            case "between":
            case "notbetween":
                qValue = qPart.value.join(" AND ");
                break;
            case "in":
            case "notin":
                qValue = qPart.value.join(",");
                break;
            default:
                qValue = qPart.value.toString();
        }
        const { fieldName, operator } = qPart;
        return `${fieldName}__${operator}=${encodeURIComponent(qValue)}`;
    })
        .join("&");
}
function tagQClause(opts) {
    const { key, value = "" } = opts;
    return {
        fieldName: "tags",
        operator: "like",
        value: `%"${key}${value && `=${value}`}"%`,
    };
}
function jobAccessUrl(opts) {
    const { job, EAI_CONSOLE_URL, human = false } = opts;
    const [protocolPrefix, consoleHost] = EAI_CONSOLE_URL.split("//");
    let jobIdentifier = job.id;
    if (human) {
        if (job.fullName) {
            jobIdentifier = job.fullName.replace(/\./g, "-");
        }
        else if (job.name && job.account.includes(".")) {
            // sometimes fullName is missing but exists (list response)
            jobIdentifier = `${job.account.replace(/\./g, "-")}-${job.name}`;
        }
        else {
            console.warn(`'human' option specified but fullName unavailable for job ${job.id}`);
        }
    }
    return consoleHost.startsWith("localhost")
        ? // the access url is different if we're using eai proxy
            `${EAI_CONSOLE_URL}/job/${jobIdentifier}`
        : `${protocolPrefix}//${jobIdentifier}.job.${consoleHost}`;
}
